let DeviceUtil = require("../util/DeviceUtil");

let getOrientation = function (location, side) {
  if (!DeviceUtil.SINGULAR_LOCATIONS.includes(location)) {
    if (side === "LEFT" || side === "RIGHT") {
      return side;
    }

    return DeviceUtil.DEFAULT_RIGHT_ORIENTATIONS.includes(location) ? "RIGHT" : "LEFT";
  }

  return "NONE";
};

let StudyDeviceConfigs = function (props) {
  let configs = [].concat(props.configs).sort((a, b) => a.createdTs - b.createdTs);

  let items = configs.map(function (config) {
    let { id, studyId, physicalConfig } = config;
    let { location, side, signal } = physicalConfig;
    let isPipeline = config.pipelineIds.length > 0;
    let isEditable = !isPipeline || config.physicalConfig.side !== "NONE";
    let modality = DeviceUtil.getMode(config);
    let hours = DeviceUtil.getRuntimeHours(config);
    let tooltip = DeviceUtil.formatConfig(config) + " (" + tx("count_hours", { _count: hours }) + ")";
    let orientation = getOrientation(location, side);
    let href = mc.router.resolve("EDIT_DEVICE_VIEW", { studyId, deviceConfigId: id });

    return (
      <li key={id}>
        <a href={props.locked || !isEditable ? null : href}>
          {isPipeline && (
            <span className="rc-study-device-configs-list-flag">
              {tx("analytics")}
            </span>
          )}
          <img
            src={`./img/rc/body.${location}.${orientation}.png`}
            width="130"
            height="130"/>
        </a>
        <div className="rc-study-device-configs-list-name">
          {tx(location)}
        </div>
        <div className="rc-study-device-configs-list-side">
          {tx("side." + side)}
        </div>
        <button
          className="rc-study-device-configs-list-modality"
          data-modality={modality}
          data-tooltip={tooltip}
          onClick={() => mc.ui.help(`./help/${rc.lang}/runtimes.html`)}>
            {tx(`${modality}.${signal || "-"}.abbr`)}
        </button>
      </li>
    );
  });

  return (
    <ul className="rc-study-device-configs-list">
      {items}
    </ul>
  );
};

module.exports = StudyDeviceConfigs;